import { StatisticsRoutes, LogsRoutes } from '../services/dictionaries/Routes';

export default [...StatisticsRoutes, ...LogsRoutes];
